module.exports = __webpack_public_path__ + "img/dice.7ea6479a.png";